import { TextArea } from './TextArea';

export type { TypeTextAreaProps } from './types';
export default TextArea;
